/**
 * Created by mukund on 1/15/17.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('CaptureService', function ($resource) {
        return {
            saveCapture: $resource('api/recording/save')
        };
    });
